import React, { useMemo, useState } from 'react';
import './ExternalRemisions.scss';
import { Button, DataGrid, Tooltip } from 'devextreme-react';
import { Column, Editing, Item, Paging, SearchPanel, Toolbar, Button as Butt, Selection, FilterRow, Pager } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { editPatient, filter } from '../../images/icons';
import { useAppSelector } from '../../contexts/hooks';
import { ModalConfigLaboratories } from './Modals/ModalConfigLaboratories';

export default () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalConfigVisible, setModalConfigVisible] = useState(false);
  const Prm_ExternalRem_Config = useAppSelector((state) => state.userInfo.Permissions?.Prm_ExternalRem_Config);
  const handleView = (e: any) => {
    // Lógica para ver los detalles de la remisión externa
    console.log('Ver remisión externa:', e.row.data);
  };

  const customDataSrc = useMemo(() => {
    return new CustomStore({
      key: 'POrd_Id',
      load: () =>
        Promise.resolve({
          data: dataSource,
          totalCount: dataSource.length,
        }),
      remove: (key) => {
        return deleteRemExt(key).then((res) => {
          if (res) {
            fetchData();
          }
        });
      },
    });
  }, [dataSource]);

  const customData = useMemo(() => {
    return new DataSource({
      store: customDataSrc,
      reshapeOnPush: true,
    });
  }, [customDataSrc]);

  const fetchData = () => {
    // Lógica para obtener los datos de las remisiones externas desde la API
  };

  const deleteRemExt = async (key: number) => {
    // Lógica para eliminar la remisión externa mediante la API
    return true;
  };

  const handleModalShowFilter = () => {
    // Lógica para mostrar el modal de filtro
  };

  const handleClicConfigClients = () => {
    setModalConfigVisible(true);
  };

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} height='100%' width={'100%'} hoverStateEnabled={true} repaintChangesOnly={true} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true}>
          <Editing allowUpdating={true} allowDeleting={true} />
          <FilterRow visible={true} applyFilter='auto' />
          <SearchPanel visible placeholder='Buscar' />
          <Selection mode='multiple' />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before'>
              {/* <div className='grid-header'>{visibleRowCount > 0 ? `${visibleRowCount} Preórdenes` : 'Preórdenes'}</div> */}
              <div className='grid-header'>Remisiones externas</div>
            </Item>
            <Item location='before' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='before' visible={Prm_ExternalRem_Config} locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNewOrd' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Configuración de laboratorios externos
              </Tooltip>
              <Button id='toolBarNewOrd' text={'Nuevo'} stylingMode='outlined' icon={editPatient} type='success' onClick={handleClicConfigClients} />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.filter-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Filtrar preórdenes
              </Tooltip>
              <Button className='filter-button' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
            </Item>
            {/*<Item location='after' visible={selectedItems.length > 0} locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Tooltip target='#toolBarNewOrd' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
              Crear órdenes seleccionadas
            </Tooltip>
            <Button id='toolBarNewOrd' text={'Nuevo'} stylingMode='outlined' icon={CreateOrders} type='success' onClick={handleClicCreateOrders} />
          </Item>
          <Item location='after' visible={selectedItems.length > 0} locateInMenu='auto'>
            <div className='separator' />
          </Item>
          <Item location='after' locateInMenu='auto'>
            <div className='separator' />
          </Item>

          <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Tooltip target='.refresh-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
              Refrescar datos
            </Tooltip>
            <Button className='refresh-button' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleUpdateData} />
          </Item> */}
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='Pc_Identificacion' caption='ID' alignment='center' width={100} />
          <Column dataField='Pc_Identificacion' caption='ID. EXT' alignment='center' width={100} />
          <Column dataField='POrd_FechaCreacion' caption='FECHA' dataType='datetime' format='dd/MM/yyyy' alignment='left' width={180} />
          <Column dataField='Us_Usuario' caption='REMITENTE' alignment='center' />
          <Column dataField='Estudios' caption='ESTADO' alignment='left' width={150} />
          <Column type='buttons' caption={'ACCIÓN'} width={120}>
            <Butt icon='eyeopen' text='Ver' onClick={handleView} />
            <Butt name='delete' text='Eliminar' />
          </Column>
        </DataGrid>
      </div>
      
      <ModalConfigLaboratories visible={modalConfigVisible} setVisible={setModalConfigVisible} />
    </div>
  );
};
